import { useGetFoldersAndFilesQuery } from '@/features/msGraph/msGraphApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import { MSG_TYPE } from '@/utils/folders';
import { Grid, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/Email';
import TableChartIcon from '@mui/icons-material/TableChart';

export const CompleteDealRecordKeeping = () => {
	const { dealRow } = useObjectContext();
	const filesQuery = useGetFoldersAndFilesQuery(
		{
			itemId: dealRow?.driveId,
			driveId: dealRow?.clientFolderDriveId,
			recursive: true,
		},
		{
			skip: !dealRow?.driveId || !dealRow?.clientFolderDriveId,
		},
	);

	const filteredFiles = useMemo(() => {
		return (filesQuery.data?.files ?? []).reduce(
			(acc, f) => {
				switch (f?.file?.mimeType) {
					case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
						acc.docx.push(f);
						break;

					case 'message/rfc822':
					case MSG_TYPE:
						acc.msg.push(f);
						break;

					case 'application/pdf':
						acc.pdf.push(f);
						break;

					case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
						acc.xlsx.push(f);
						break;

					default:
						break;
				}

				return acc;
			},
			{
				msg: [],
				pdf: [],
				docx: [],
				xlsx: [],
			},
		);
	}, [filesQuery.data?.files]);

	const iconProps = {
		sx: (theme) => ({ fontSize: '18px', color: theme.palette.folioBlack100 }),
	};
	const items = [
		{
			value: filteredFiles.msg.length,
			label: 'Emails saved',
			icon: <EmailIcon {...iconProps} />,
		},
		{
			value: filteredFiles.docx.length,
			label: 'Word .docx saved',
			icon: <DescriptionIcon {...iconProps} />,
		},
		{
			value: filteredFiles.pdf.length,
			label: 'Pdfs saved',
			icon: <PictureAsPdfIcon {...iconProps} />,
		},
		{
			value: filteredFiles.xlsx.length,
			label: 'Excel .xlsx saved',
			icon: <TableChartIcon {...iconProps} />,
		},
	];

	return (
		<Grid container spacing={1} width='100%'>
			{items.map((item) => (
				<Grid key={item.label} size={{ xs: 12, sm: 6, md: 6 }}>
					<Stack direction='row' spacing={1.5} sx={{ alignItems: 'center' }}>
						<Typography variant='h6' sx={{ fontWeight: 'bold' }}>
							{item.value}
						</Typography>
						<Stack direction='row' spacing={0.5} sx={{ alignItems: 'center' }}>
							{item.icon}
							<Typography>{item.label}</Typography>
						</Stack>
					</Stack>
				</Grid>
			))}
		</Grid>
	);
};
